import React from 'react'

import { Hero, ContextType, convertSize } from '@sketch/discover'

import { GenericSectionTitle, Grid } from '@sketch/components'
import { CommunityItemFragment } from '@sketch/gql-types'

import CommunityPublicationListing from '../CommunityPublicationListing'
import CommunityPublicationGrid from '../CommunityPublicationGrid'
import CommunityPublicationSlider from '../CommunityPublicationSlider'

export interface EditorialItemProps {
  item: CommunityItemFragment
  context: ContextType
}

// Helpers
const COMPONENTS_BY_TYPE = {
  CommunityHero: Hero,
  CommunityListing: CommunityPublicationListing,
  CommunityGrid: CommunityPublicationGrid,
  CommunitySlider: CommunityPublicationSlider,
}

/**
 * EditorialItem
 *
 * Responsible for rendering the content of Sections for the Community page
 */
const EditorialItem: React.FC<EditorialItemProps> = ({ item, context }) => {
  if (item.__typename === 'CommunityHero') {
    return (
      <Grid.Column key={item.id} {...convertSize(item.size)}>
        <Hero {...item} context={context} />
      </Grid.Column>
    )
  }

  const Component = COMPONENTS_BY_TYPE[item.__typename]

  return (
    <Grid.Column key={item.id}>
      <GenericSectionTitle
        title={item.title}
        subTitle={item.subTitle || undefined}
        titleLink={
          item.link
            ? { text: item.link.text || undefined, url: item.link.url }
            : undefined
        }
      />
      <Component {...item} analyticsId={item.id} />
    </Grid.Column>
  )
}

export default EditorialItem
